import theme from "js/material-ui-theme";

export const ORDER_STATUS_COLORS = {
    PENDENTE: theme.palette.error.light,
    EM_ANDAMENTO: theme.palette.info.light,
    FATURADO: theme.palette.info.dark,
    PREPARADO: theme.palette.success.main,
    CONFIRMADO: theme.palette.warning.light,
    CONCLUIDO: 'green',
    CANCELADO:'rgba(0, 0, 0, 0.54)',
}